import { computed } from '@vue/composition-api';

export default function useGetPaid (booking) {
  const paid = computed(() => {
    const bookingStationTimes = booking.value.bookingStationTimes;
    if (bookingStationTimes.length === 0) return false;
    return bookingStationTimes.reduce((price, bookingStationTime) => {
      return bookingStationTime.amountDue + price;
    }, 0) === 0;
  });

  return {
    paid,
  };
}
